import { render } from "./VorstandView.vue?vue&type=template&id=20c01067&scoped=true"
import script from "./VorstandView.vue?vue&type=script&lang=js"
export * from "./VorstandView.vue?vue&type=script&lang=js"

import "./VorstandView.vue?vue&type=style&index=0&id=20c01067&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c01067"]])

export default __exports__